<template lang="pug" src="../templates/farm.pug" />

<script>
import {mapActions, mapGetters, mapMutations} from "vuex"
import subMonths from "date-fns/sub_months"
import subYears from "date-fns/sub_years"
import getTime from "date-fns/get_time"
import _filter from "lodash/filter"
import _flatMapDeep from "lodash/flatMapDeep"

export default {
    name: "Farm",
    data() {
        return {
            farm: {},

        }
    },
    computed: {
        ...mapGetters([
            'selectedFarm',
            'selectedFarmId',
            'animals',
            'bulls',
            'culled',
            'cattleLoading'
        ]),
        todayLessAMonth() {
            return Math.trunc(getTime(subMonths(Date.now(), 1)) / 1000)
        },
        todayLessAYear() {
            return Math.trunc(getTime(subYears(Date.now(), 1)) / 1000)
        },
        getHeiferLastMonthCount() {
            let self = this
            return _filter(this.animals, function(a) {
                return a.type === 'heifer' && a.birthday > self.todayLessAMonth
            }).length
        },
        getHeiferLastYearCount() {
            let self = this
            return _filter(this.animals, function(a) {
                return a.type === 'heifer' && a.birthday > self.todayLessAYear
            }).length
        },
        getCalfLastMonthCount() {
            let self = this
            return _filter(this.bulls, function(a) {
                return a.type === 'calf' && a.birthday > self.todayLessAMonth
            }).length
        },
        getCalfLastYearCount() {
            let self = this
            return _filter(this.bulls, function(a) {
                return a.type === 'calf' && a.birthday > self.todayLessAYear
            }).length
        },
        getCulledLastMonthCount() {
            let self = this
            return _filter(_flatMapDeep(this.animals, 'states'), function(s) {
                return ['sold', 'dead', 'abortion', 'stillbirth', 'stillbirth-dead', 'cull'].includes(s.state) && s.date > self.todayLessAMonth
            }).length.toString()
        },
        getCulledLastYearCount() {
            let self = this
            return _filter(_flatMapDeep(this.animals, 'states'), function(s) {
                return ['sold', 'dead', 'abortion', 'stillbirth', 'stillbirth-dead', 'cull'].includes(s.state) && s.date > self.todayLessAYear
            }).length.toString()
        }
    },
    created() {
        this.$store.commit('resetTableOrder')
        if (parseInt(this.$attrs.farmId) !== this.selectedFarmId || this.animals.length === 0) {
            this.$store.commit('selectFarm', parseInt(this.$attrs.farmId))
            this.$store.commit('resetAnimals')
            this.fetchAnimals()
            this.fetchBulls()
            this.fetchCulled()
        }
    },
    methods: {
        ...mapMutations([
            'selectFarm',
            'updateTableOrder'
        ]),
        ...mapActions(['fetchAnimals', 'fetchBulls', 'fetchCulled']),
        getStateLastMonth(params) {
            let self = this
            return _filter(_flatMapDeep(this.animals, 'states'), function(s) {
                return params.includes(s.state) && s.date > self.todayLessAMonth
            }).length.toString()
        },
        getStateLastYear(params) {
            let self = this
            return _filter(_flatMapDeep(this.animals, 'states'), function(s) {
                return params.includes(s.state) && s.date > self.todayLessAYear
            }).length.toString()
        }
    }
}
</script>

<style lang="sass" scoped>
    @import '../sass/mixin/color'
    @import '../sass/mixin/flex'

    .container#farm-summary
        padding-left: 279px
        padding-top: 0
        padding-right: 0
    #farm-summary
        #farm-header
            width: 100%
            @include flexbox
            @include justify-content(center)
            @include align-content(center)
            background: linear-gradient(69.83deg, #0084f4 0%, #00c48c 100%)
            color: white
            font-size: 64px
        #farm-body
            @include flexbox
            @include flex-direction(row)
            @include flex-wrap(wrap)
            @include justify-content(flex-start)
            padding: 100px
            .card-info
                //max-height: 150px
                min-width: 150px
                margin-bottom: 15px
                margin-right: 20px

            .card-info .wrap
                background: #ffffff
                box-shadow: 2px 10px 20px rgba(0, 0, 0, 0.1)
                border-radius: 7px
                text-align: center
                position: relative
                overflow: hidden
                padding: 40px 25px 20px
                height: 100%

            .card-info__title
                color: #6c6c6c
                font-size: 1.30em
            .card-info__subInfo
                color: #6c6c6c
                font-size: 0.85em
                text-align: left

            .card-info span
                display: block

            .card-info__count
                font-weight: 600
                font-size: 2.2em
                line-height: 64px
                color: #323c43
                &.count-medium
                    font-size: 1.8em
                    line-height: 48px
                    color: #323c43

            .card-info .wrap:after
                display: block
                position: absolute
                top: 0
                left: 0
                width: 100%
                height: 10px
                content: ""


            .card-info:nth-child(1) .wrap:after
                background: linear-gradient(81.67deg, #0084f4 0%, #1a4da2 100%)

            .card-info:nth-child(2) .wrap:after
                background: linear-gradient(81.67deg, #0084f4 0%, #1a4da2 100%)

            .card-info:nth-child(3) .wrap:after
                background: linear-gradient(81.67deg, #0084f4 0%, #1a4da2 100%)

            .card-info .wrap:after
                background: linear-gradient(81.67deg, #ff647c 0%, #1f5dc5 100%)

            .card-info__title svg
                color: #d7d7d7
                margin-left: 5px

            .MuiSvgIcon-root-19
                fill: currentColor
                width: 1em
                height: 1em
                display: inline-block
                font-size: 24px
                transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms
                user-select: none
                flex-shrink: 0


</style>